import request from '@/config/axios'
import type { OrderGuestVO } from './orderGuest'

export interface BookingOrderVO {
  id: string | number
  orderNo: string
  shopId: string | number
  shopName?: string
  spuId: string | number
  spuName?: string
  skuId?: string | number
  roomId: string | number
  roomNo?: string
  memberId?: string | number
  checkInDate: string
  checkOutDate: string
  guestName: string
  guestPhone: string
  roomCount: number
  totalPrice: number
  payAmount: number
  payOrderId?: string | number
  depositAmount?: number
  depositStatus?: number
  depositPayOrderId?: string | number
  refundAmount?: number
  refundStatus?: number
  refundTime?: string
  refundReason?: string
  status: number // 0待支付 1已支付 2已确认 3已入住 4已完成 5已取消
  cancelReason?: string
  payTime?: string
  checkInTime?: string
  checkOutTime?: string
  remark?: string
  createTime?: string
  guests?: OrderGuestVO[]
}

// 分页查询
export const getBookingOrderPage = (params: any) => {
  return request.get({ url: '/hotel/booking-order/page', params })
}

// 获取详情
export const getBookingOrder = (id: string | number) => {
  return request.get({ url: '/hotel/booking-order/get?id=' + id })
}

// 创建订单
export const createBookingOrder = (data: BookingOrderVO) => {
  return request.post({ url: '/hotel/booking-order/create', data })
}

export const quickCheckIn = (data: BookingOrderVO & { paymentMethod: string; paymentRemark?: string }) => {
  return request.post({ url: '/hotel/booking-order/quick-check-in', data })
}

// 更新订单
export const updateBookingOrder = (data: BookingOrderVO) => {
  return request.put({ url: '/hotel/booking-order/update', data })
}

// 删除订单
export const deleteBookingOrder = (id: string | number) => {
  return request.delete({ url: '/hotel/booking-order/delete?id=' + id })
}

// 确认订单
export const confirmBookingOrder = (id: string | number) => {
  return request.put({ url: '/hotel/booking-order/confirm?id=' + id })
}

// 取消订单
export const cancelBookingOrder = (id: string | number, cancelReason: string) => {
  return request.put({ url: '/hotel/booking-order/cancel?id=' + id + '&cancelReason=' + encodeURIComponent(cancelReason) })
}

// 入住登记
export const checkIn = (id: string | number) => {
  return request.put({ url: '/hotel/booking-order/check-in?id=' + id })
}

// 退房
export const checkOut = (id: string | number) => {
  return request.put({ url: '/hotel/booking-order/check-out?id=' + id })
}

export const collectDeposit = (orderId: string | number, amount: number) => request.put({ url: '/hotel/booking-order/collect-deposit', params: { orderId, amount } })
export const refundDeposit = (orderId: string | number, amount: number, reason: string) => request.put({ url: '/hotel/booking-order/refund-deposit', params: { orderId, amount, reason } })
export const refund = (orderId: string | number, amount: number, reason: string) => request.put({ url: '/hotel/booking-order/refund', params: { orderId, amount, reason } })

export const getDetailWithGuests = (id: string | number) =>
  request.get<BookingOrderVO>({ url: '/hotel/booking-order/detail-with-guests?id=' + id })
